import React from 'react';
import Carousel from 'react-multi-carousel';
import { isIterableArray } from '../../helpers/utils';
import API from '../../config/config';

const CarouselWidget = (props: any) => {
  const responsive = {
    desktop: {
      breakpoint: { max: 20000, min: 990 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 990, min: 0 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    }
  };

  const CustomRightArrow = ({ onClick, ...rest }: any) => {
    return (
      <button onClick={() => onClick()} className="btncarousel-widget btncarousel-widget-arrow-right" aria-label="fa-chevron-right">
        <span className="fas fa-chevron-right arrow" />
      </button>
    );
  };

  const CustomLeftArrow = ({ onClick, ...rest }: any) => {
    return (
      <button onClick={() => onClick()} className="btncarousel-widget btncarousel-widget-arrow-left" aria-label="fa-chevron-left">
        <span className="fas fa-chevron-left arrow" />
      </button>
    );
  };

  return (
    <div>
      <div className="container product-carouselWidget">
        <div className="carousel-size">
          <Carousel
            swipeable
            draggable
            showDots
            responsive={responsive}
            ssr={true} // means to render carousel on server-side.
            infinite
            autoPlay={false}
            autoPlaySpeed={5000}
            arrows={true}
            //renderDotsOutside
            keyBoardControl
            customTransition="transform 500ms ease-in-out"
            transitionDuration={500}
            containerClass="carousel-container"
            deviceType={props.deviceType}
            dotListClass="custom-dot-list-style"
            itemClass="pro-carouselWidget-image-align"
            customRightArrow={<CustomRightArrow />}
            customLeftArrow={<CustomLeftArrow />}
          >
            {isIterableArray(props.data) &&
              props.data.map((item: any, i: any) => {
                return (
                  <div
                    key={i}
                    style={{ backgroundImage: 'url(' + API.baseUrl + item.url + ')' }}
                    draggable={false}
                    className="img-size"
                  />
                );
              })}
          </Carousel>
        </div>
      </div>
    </div>
  );
};

export default CarouselWidget;
